import { render, staticRenderFns } from "./LoanCollateralView.vue?vue&type=template&id=3b98c0d4&lang=pug&"
import script from "./LoanCollateralView.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports